import React, { useState, useEffect } from 'react';

import '../../styles/tables.css';
import '../../styles/buttons.css';

const PageTable = ({
    rows = [],
    columns = [],
    hasButtons = false,
    hasEdit = false,
    hasDelete = false,
    hasCheckout = false,
    hasModal = false,
    hasExpansion = false,
    onEdit,
    onDelete,
    onCheckout,
    onRowClick,
    clickedRowId,
    renderRowExpansion,
    renderRowModal
}) => {
    const [sortConfig, setSortConfig] = useState({ key: '', direction: 'asc' });
    const [sortedRows, setSortedRows] = useState([]);

    // Edited this; check with Johan if he did the same
    useEffect(() => {
        let filtered = [...rows];

        if (sortConfig.key) {
            filtered.sort((a, b) => {
                const getValue = (obj, key) => {
                    if (typeof key === 'function') return key(obj); // handle function accessor
                    if (typeof key === 'string') {
                        return key.split('.').reduce((o, k) => (o ? o[k] : ''), obj);
                    }
                    return '';
                };

                const aValue = getValue(a, sortConfig.key);
                const bValue = getValue(b, sortConfig.key);

                // Compare numbers, dates, or strings safely
                const normalize = (val) => {
                    if (val == null) return '';
                    if (val instanceof Date) return val.getTime();
                    if (!isNaN(Date.parse(val))) return new Date(val).getTime();
                    return val.toString().toLowerCase();
                };

                const A = normalize(aValue);
                const B = normalize(bValue);

                if (A < B) return sortConfig.direction === 'asc' ? -1 : 1;
                if (A > B) return sortConfig.direction === 'asc' ? 1 : -1;
                return 0;
            });
        }

        setSortedRows(filtered);
    }, [rows, sortConfig]);

    const handleSort = (key) => {
        let direction = 'asc';
        if (sortConfig.key === key) {
            if (sortConfig.direction === 'asc') direction = 'desc';
            else if (sortConfig.direction === 'desc') direction = '';
        }
        setSortConfig({ key: direction === '' ? '' : key, direction });
    };

    return (
        <div className="page-table-container">
            <table className="page-table">
                <colgroup>
                    {columns.map((col, index) => (
                        <col
                            key={index}
                            style={{ width: col.width || `${95 / columns.length}%` }}
                        />
                    ))}
                    {hasButtons && <col style={{ width: '5%' }} />}
                </colgroup>
                <thead>
                    <tr>
                        {columns.map((col) => (
                            <th
                                key={col.accessor}
                                className={sortConfig.key === col.accessor ? 'active' : ''}
                                onClick={() => handleSort(col.accessor)}
                                style={{ textAlign: 'center', cursor: 'pointer' }}
                            >
                                {col.label}
                                {sortConfig.key === col.accessor && sortConfig.direction && (
                                    <span
                                        className={`sort-arrow ${sortConfig.direction === 'asc' ? 'sort-asc' : 'sort-desc'
                                            }`}
                                    />
                                )}
                            </th>
                        ))}
                        {hasButtons && <th style={{ textAlign: 'center' }}></th>}
                    </tr>
                </thead>
                <tbody>
                    {sortedRows.length === 0 ? (
                        <tr>
                            <td colSpan={columns.length + (hasButtons ? 1 : 0)} style={{ textAlign: 'center', padding: '1rem' }}>
                                No data found.
                            </td>
                        </tr>
                    ) : (
                        sortedRows.map((row, rowIndex) => (
                            <React.Fragment key={row._id}>
                                <tr onClick={() => onRowClick && onRowClick(row)}>
                                    {columns.map((col) => {
                                        const value =
                                            typeof col.accessor === 'function'
                                                ? col.accessor(row, rowIndex)
                                                : col.accessor.split('.').reduce((obj, key) => (obj ? obj[key] : null), row);

                                        return (
                                            <td key={col.label} style={{ textAlign: 'center' }}>
                                                {value != null && value !== '' ? value : '—'}
                                            </td>
                                        );
                                    })}
                                    {hasButtons && (
                                        <td style={{ width: '5%', textAlign: 'center' }}>
                                            <div className="button-group" onClick={(e) => e.stopPropagation()}>
                                                {hasDelete && (
                                                    <button className="action-buttons" onClick={() => onDelete(row)}>
                                                        <i className="fas fa-trash"></i>
                                                    </button>
                                                )}
                                                {hasEdit && (
                                                    <button className="action-buttons" onClick={() => onEdit(row)}>
                                                        <i className="fas fa-edit"></i>
                                                    </button>
                                                )}
                                                {hasCheckout && (
                                                    <button
                                                        className={`action-buttons ${row.checkOut ? 'disabled' : ''}`}
                                                        onClick={() => onCheckout(row)}
                                                        disabled={!!row.checkOut}
                                                    >
                                                        <i className="fas fa-clipboard-check"></i>
                                                    </button>
                                                )}
                                            </div>
                                        </td>
                                    )}
                                </tr>
                                {clickedRowId === row._id && (
                                    <>
                                        {hasExpansion && renderRowExpansion && (
                                            <tr className="expanded-row">
                                                <td colSpan={columns.length + (hasButtons ? 1 : 0)}>
                                                    {renderRowExpansion(row)}
                                                </td>
                                            </tr>
                                        )}
                                        {hasModal && renderRowModal && (
                                            <tr className="modal-row">
                                                <td colSpan={columns.length + (hasButtons ? 1 : 0)}>
                                                    {renderRowModal(row)}
                                                </td>
                                            </tr>
                                        )}
                                    </>
                                )}
                            </React.Fragment>
                        ))
                    )}
                </tbody>
            </table>
        </div>
    );
};

export default PageTable;
